import script from "./ProfessionPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfessionPage.vue?vue&type=script&lang=ts&setup=true"

import "./ProfessionPage.vue?vue&type=style&index=0&id=16037b14&scoped=true&lang=css"

import exportComponent from "D:\\code\\frontEndCode\\collegeSubjectPage\\page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16037b14"]])

export default __exports__